// src/utils/adminHelper.js - Secure Admin Role Verification Helper
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

/**
 * Verify if current user has admin role via Firestore
 * @param {Object} currentUser - Firebase auth user object  
 * @returns {Promise<Object>} { isAdmin: boolean, error: string|null, userData: Object|null }
 */
export const verifyAdminRole = async (currentUser) => {
  try {
    if (!currentUser || !currentUser.email) {
      return { 
        isAdmin: false, 
        error: 'Niet ingelogd',
        userData: null 
      };
    }

    // Load user profile from Firestore users collection
    const userDoc = await getDoc(doc(db, 'users', currentUser.email));
    
    if (!userDoc.exists()) {
      console.warn('User profile niet gevonden:', currentUser.email);
      return { 
        isAdmin: false, 
        error: 'Gebruikersprofiel niet gevonden',
        userData: null 
      };
    }

    const userData = userDoc.data();
    
    // Check if user has admin role
    const isAdmin = userData.role === 'admin';
    
    console.log(`Admin verificatie voor ${currentUser.email}:`, {
      role: userData.role,
      isAdmin: isAdmin,
      organizationId: userData.organizationId
    });

    return {
      isAdmin: isAdmin,
      error: null,
      userData: userData
    };

  } catch (error) {
    console.error('Admin verificatie fout:', error);
    return {
      isAdmin: false,
      error: 'Verificatie mislukt: ' + error.message,
      userData: null
    };
  }
};

/**
 * Get admin dashboard statistics from Firestore
 * @returns {Promise<Object>} { success: boolean, data: Object|null, error: string|null }
 */
export const getAdminDashboardStats = async () => {
  try {
    // Voor nu mock data - kan later uitgebreid worden met echte Firestore queries
    const stats = {
      totalTeams: 12,
      totalResponses: 89,
      totalInvitations: 156,
      emailsSent: 203,
      lastUpdated: new Date().toISOString()
    };

    // TODO: Implementeer echte statistieken:
    // const teamsSnapshot = await getDocs(collection(db, 'teams'));
    // stats.totalTeams = teamsSnapshot.size;
    
    return {
      success: true,
      data: stats,
      error: null
    };

  } catch (error) {
    console.error('Admin stats fout:', error);
    return {
      success: false,
      data: null,
      error: error.message
    };
  }
};